module.exports = __webpack_public_path__ + "static/media/house.5c8664b8.svg";